import script from "./userTransfer.vue?vue&type=script&setup=true&lang=js"
export * from "./userTransfer.vue?vue&type=script&setup=true&lang=js"

import "./userTransfer.vue?vue&type=style&index=0&id=5ec6b00e&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ec6b00e"]])

export default __exports__